// Timezone-aware display for full UTC timestamps (game start times).
// NEVER use for date-only values — use formatDateOnly for those.
import { formatInTimeZone } from "date-fns-tz";

export const DEFAULT_TZ = "America/New_York";

// Render a UTC ISO timestamp in the given IANA tz, with tz abbreviation.
export function formatInTz(utcIso, tz = DEFAULT_TZ, pattern = "MMM d, yyyy h:mm a") {
  if (!utcIso) return "—";
  try {
    return `${formatInTimeZone(new Date(utcIso), tz, pattern)} ${formatInTimeZone(new Date(utcIso), tz, "zzz")}`;
  } catch {
    return "—";
  }
}

export const TZ_OPTIONS = [
  "America/New_York", "America/Los_Angeles", "America/Chicago",
  "Europe/London", "Europe/Berlin", "Europe/Madrid", "Africa/Accra", "UTC",
];
